import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Datastore, User } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontSize, FontWeight } from '@freelancer/ui/text';
import * as Rx from 'rxjs';
import { CallType as CallTypeChatBox } from '../chat-box/chat-box.component';

type CallType = CallTypeChatBox;

@Component({
  selector: 'app-call-alert-modal',
  template: `
    <fl-display-card>
      <fl-display-card-header-left>
        <fl-bit class="HeaderTopRow" *ngIf="callType === 'Audio'">
          <fl-icon
            [name]="'ui-phone'"
            [color]="IconColor.MID"
            [size]="IconSize.SMALL"
          ></fl-icon>
          <fl-text
            [color]="FontColor.MID"
            [size]="FontSize.SMALL"
            i18n="Chatbox incoming call description"
          >
            Incoming Audio Call
          </fl-text>
        </fl-bit>
        <fl-bit class="HeaderTopRow" *ngIf="callType === 'Video'">
          <fl-icon
            [name]="'ui-video-camera'"
            [color]="IconColor.MID"
            [size]="IconSize.SMALL"
          ></fl-icon>
          <fl-text
            [color]="FontColor.MID"
            [size]="FontSize.SMALL"
            i18n="Chatbox incoming call description"
          >
            Incoming Video Call
          </fl-text>
        </fl-bit>
        <fl-text
          *ngFor="let member of (otherMembers$ | async)"
          [color]="FontColor.DARK"
          [size]="FontSize.LARGE"
          [weight]="FontWeight.BOLD"
        >
          {{ member.displayName }}
        </fl-text>
      </fl-display-card-header-left>
      <fl-display-card-content>
        <fl-bit class="CallContent">
          <fl-bit class="Animation" [flMarginBottom]="Margin.SMALL">
            <fl-bit [ngClass]="['Circle', 'CircleAvatar']">
              <fl-user-avatar [users]="otherMembers$ | async" [size]="'xlarge'">
              </fl-user-avatar>
            </fl-bit>
            <fl-bit class="PulseRing"></fl-bit>
          </fl-bit>
          <fl-bit class="ActionButtons">
            <fl-button
              [ngClass]="['Circle', 'CircleIcon', 'CircleIconAccept']"
              (click)="handleCallAccept()"
            >
              <fl-icon
                [name]="'ui-phone'"
                [color]="IconColor.LIGHT"
                [size]="IconSize.MID"
              ></fl-icon>
            </fl-button>
            <fl-button
              [ngClass]="['Circle', 'CircleIcon', 'CircleIconDecline']"
              (click)="handleCallDecline()"
            >
              <fl-icon
                [name]="'ui-phone'"
                [color]="IconColor.LIGHT"
                [size]="IconSize.MID"
              ></fl-icon>
            </fl-button>
          </fl-bit>
        </fl-bit>
      </fl-display-card-content>
    </fl-display-card>
  `,
  styleUrls: ['call-alert-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallAlertModalComponent implements OnInit {
  Margin = Margin;
  IconColor = IconColor;
  IconSize = IconSize;
  FontColor = FontColor;
  FontSize = FontSize;
  FontWeight = FontWeight;

  @Input() otherUserIds: ReadonlyArray<number>;
  @Input() callType: CallType;
  @Input() threadId: number;

  otherMembers$: Rx.Observable<ReadonlyArray<User>>;

  constructor(
    private modalRef: ModalRef<CallAlertModalComponent>,
    private datastore: Datastore,
  ) {}

  ngOnInit() {
    this.otherMembers$ = this.datastore.objects('users', this.otherUserIds);
  }

  handleCallAccept() {
    this.modalRef.close(true);
  }

  handleCallDecline() {
    this.modalRef.close(false);
  }
}
